import React from 'react'
import PropTypes from 'prop-types'
import More from '@mui/icons-material/MoreVert'

const MoreIcon = ({ height, width, ...more }) => {
	
	return (
		<More
			height={height}
			width={width}
			{...more}
		/>
	)
}

MoreIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default MoreIcon
